import { Alert, AlertProps, Snackbar } from "@mui/material";
import React from "react";

const Notify = ({
  open,
  setOpen,
  message,
  severity,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  message: string;
  severity: AlertProps["severity"];
}): JSX.Element => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Alert
        onClose={() => {
          setOpen(false);
        }}
        severity={severity}
        sx={{ width: "100%" }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Notify;
